/**
 * CSS `url(...)` только для http(s) и путей от корня: адреса постеров приходят из БД,
 * поэтому `javascript:`, `data:` и прочее отбрасываем (как и в старой версии для обложек).
 */
export function safeCssUrl(raw: string | null | undefined): string | undefined {
  if (!raw) return undefined;
  const value = raw.trim();
  if (!/^(https?:\/\/|\/(?!\/))/i.test(value)) return undefined;
  return `url("${encodeURI(value).replace(/"/g, "%22")}")`;
}

/** Страница фильма на Кинопоиске; без kinopoisk_id — поиск по названию. */
export function kinopoiskUrl(film: { kinopoisk_id: number | null; title: string }): string {
  return film.kinopoisk_id
    ? `https://www.kinopoisk.ru/film/${film.kinopoisk_id}/`
    : `https://www.kinopoisk.ru/index.php?kp_query=${encodeURIComponent(film.title)}`;
}

/** Ссылка-приглашение: открывает Mini App и сразу подключает к комнате (start_param = код). */
export function inviteLink(botLink: string, roomId: string): string {
  return `${botLink}?startapp=${encodeURIComponent(roomId)}`;
}

/** Ссылка диалога «Поделиться» в Telegram. */
export function shareUrl(link: string, roomId: string): string {
  const text = `Присоединяйся к комнате!\n\nКод комнаты: ${roomId}`;
  return `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`;
}
